import React from "react";
var useAnimationTimeoutEffect = function useAnimationTimeoutEffect(animationState, resetAnimation) {
  React.useEffect(function () {
    /**
     * Animation is supposed to last 250ms. This will kick in if no animation happens
     */
    var timeout = 300;
    // Create a timeout to 'end' animation if no actual transition is triggered after a drag.
    //
    // For example, these events happen:
    //    MouseDown[x: 0] -> MouseMove[x: 1] -> MouseMove[x: 0] -> MouseUp[x: 0]
    //
    // In this case, the animation state changes to `ADJUST`, but because
    // no CSS transition is actually triggered, we never change from that state, since we rely on
    // `onTransitionEnd` callback to reset the animation state.

    if (animationState === 'ADJUST') {
      resetAnimation(timeout);
    }
  }, [animationState, resetAnimation]);
};
export default useAnimationTimeoutEffect;